<!-- 三方推流设置界面 -->
<template>
<div class="vmp-third-stream">
  <!-- 第三方推流 -->
  <div class="vmp-third-stream-box">
    <div class="vmp-third-stream-title">{{ $t('lang.k_397001') }}<span class="vmp-third-stream-subTitle">{{ $t('lang.k_397002') }}</span>
    </div>
    <div class="vmp-third-stream-modal" :class="'streamModal' + streamModal">
      <div class="title">{{ $t('lang.k_397003') }}</div>
      <vh-radio-group v-model="streamModal">
        <vh-radio :label="1">{{ $t('lang.k_397004') }}</vh-radio>
        <vh-radio :label="2">{{ $t('lang.k_397005') }}</vh-radio>
      </vh-radio-group>
      <div class="input-item" v-show="streamModal == 1">
        <label>RTMP/URL</label>
        <div class="vmp-third-stream-modal-input readOnly">
          <span class="input" :title="thirdWatchWebUrl">{{ thirdWatchWebUrl }}</span>
          <span class="tool">
            <span :title="$t('lang.k_397006')" @click="doCopy(1)" class="vh-iconfont vh-line-copy"></span>
          </span>
        </div>
      </div>
      <div class="input-item" v-show="streamModal == 1">
        <label>{{ $t('lang.k_397007') }}</label>
        <div class="vmp-third-stream-modal-input readOnly">
          <span class="input" :title="thirdPlayUrl">{{ thirdPlayUrl }}</span>
          <span class="tool">
            <span :title="$t('lang.k_397006')" @click="doCopy(2)" class="vh-iconfont vh-line-copy"></span>
          </span>
        </div>
      </div>
      <div class="input-item" v-show="streamModal == 2">
        <label>
          <span class="required">*</span>{{ $t('lang.k_397008') }}</label>
        <div
          class="vmp-third-stream-modal-input"
          :class="showRulePullUrl ? 'showRulePullUrl' : ''"
        >
          <vh-input v-model="pullUrl" :placeholder="$t('lang.k_397009')"></vh-input>
          <vh-button class="save-btn" type="text" @click="validatePullUrl">{{ $t('lang.k_397010') }}</vh-button>
          <span class="alert" v-show="showRulePullUrl">
            {{ pullUrl ? $t('lang.k_397011') : $t('lang.k_397012') }}
          </span>
        </div>
      </div>
      <div class="input-item">
        <label>{{ $t('lang.k_397013') }}</label>
        <div class="vmp-third-stream-modal-input readOnly">
          <span class="input" :class="!!streamStatus ? 'success' : 'fail'">
            {{ !!streamStatus ? $t('lang.k_397014') : $t('lang.k_397015') }}
          </span>
          <span class="tool">
            <span
              :title="$t('lang.k_397016')"
              @click="getThirdPushStreamStatus"
              class="vh-iconfont vh-line-refresh-right"
            ></span>
          </span>
        </div>
      </div>
      <div class="separator"></div>
      <template v-if="streamModal == 1">
        <div class="title">{{ $t('lang.k_397017') }}</div>
        <div class="content">
          <p>{{ $t('lang.k_397018') }}</p>
          <p>{{ $t('lang.k_397019') }}</p>
          <p style="color: #fb3a32">{{ $t('lang.k_397020') }}</p>
          <p>{{ $t('lang.k_397021') }}</p>
          <p>{{ $t('lang.k_397022') }}</p>
          <p style="color: #fb3a32">{{ $t('lang.k_397023') }}<a
              style="color: #436dfa; margin-left: 10px"
              href="https://saas-doc.vhall.com/opendocs/show/1746"
              target="_blank"
            >{{ $t('lang.k_397024') }}</a>
          </p>
        </div>
        <div class="title">{{ $t('lang.k_397025') }}<a href="https://saas-doc.vhall.com/opendocs/show/1666" target="_blank">{{ $t('lang.k_397024') }}</a>
        </div>
        <div class="content">
          <p>{{ $t('lang.k_397026') }}</p>
          <p>{{ $t('lang.k_397027') }}</p>
          <p style="color: #fb3a32">{{ $t('lang.k_397028') }}</p>
          <p class="notice">{{ $t('lang.k_397029') }}</p>
        </div>
      </template>
      <template v-else>
        <div class="title">{{ $t('lang.k_397030') }}</div>
        <div class="content">
          <p>{{ $t('lang.k_397031') }}</p>
          <p style="color: #fb3a32">{{ $t('lang.k_397032') }}</p>
        </div>
        <div class="title">{{ $t('lang.k_397033') }}</div>
        <div class="content">
          <p>{{ $t('lang.k_397034') }}</p>
        </div>
      </template>
    </div>
  </div>
  <begin-play :webinarId="$route.params.str"></begin-play>
</div>
</template>
<script>

import { copy } from '@/utils/utils';
import regRule from '@/utils/reg-rule.js';
import beginPlay from '@/components/beginBtn';
export default {
  name: 'VmpThirdStream',
  data() {
    return {
      thirdWatchWebUrl: '',
      thirdPlayUrl: '',
      streamModal: 1,
      pullUrl: '',
      showRulePullUrl: false,
      //是否有流：0-无，1-有
      streamStatus: 0
    };
  },
  components: {
    beginPlay
  },
  beforeCreate() {},
  computed: {},
  watch: {
    pullUrl(val) {
      if (val) {
        this.showRulePullUrl = false;
      }
    }
  },
  created() {
    this.getThirdPushStream();
    this.getThirdPushStreamStatus();
    this.getStreamPullAddress();
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    getStreamPullAddress() {
      this.$fetch('getStreamPullAddress', { webinar_id: this.$route.params.str }).then((res) => {
        if (res.code == 200) {
          this.pullUrl = res.data.dest_url;
        }
      });
    },
    getThirdPushStream() {
      this.$fetch('getStreamPushAddress', { webinar_id: this.$route.params.str }).then((res) => {
        if (res.code == 200) {
          this.thirdPlayUrl = res.data.stream_code;
          this.thirdWatchWebUrl = res.data.stream_address;
        }
      });
    },
    //刷新房间内流状态
    getThirdPushStreamStatus() {
      this.$fetch('getLiveStreamStatus', {
        webinar_id: this.$route.params.str
      }).then((res) => {
        if (res.code == 200) {
          this.streamStatus = res.data.status;
        }
      });
    },
    doCopy(type) {
      copy(type == 1 ? this.thirdWatchWebUrl : this.thirdPlayUrl);
      this.$message({
        message: this.$t("lang.k_397035"),
        showClose: true,
        type: 'success',
        customClass: 'zdy-info-box'
      });
    },
    //校验拉流地址非法性
    validatePullUrl() {
      if (!this.pullUrl) {
        this.showRulePullUrl = true;
      } else {
        const reg = regRule.pullUrl;
        if (reg.test(this.pullUrl)) {
          this.showRulePullUrl = false;
          this.$fetch('setStreamPullAddress', {
            webinar_id: this.$route.params.str,
            dest_url: this.pullUrl
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: this.$t("lang.k_397036"),
                showClose: true,
                type: 'success',
                customClass: 'zdy-info-box'
              });
            }
          });
        } else {
          this.showRulePullUrl = true;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
  .vmp-third-stream {
    &-box {
      margin: 0 auto;
      width: 100%;
      height: 100%;
    }
    &-title {
      // width: 820px;
      margin: 0 auto;
      padding-bottom: 10px;
      font-weight: 600;
      overflow: auto;
      font-size: 20px;
      line-height: 28px;
      color: #1a1a1a;
    }
    &-subTitle {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999999;
      margin-left: 8px;
    }
    &-modal {
      // width: 720px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 4px;
      padding: 24px;
      box-sizing: border-box;
      color: #1a1a1a;
      &.streamModal2 {
        .input-item label {
          min-width: 68px;
          width: 68px;
        }
        .required {
          color: #fb3a32;
        }
        input {
          border-color: #ccc;
        }
        .vh-input__inner:focus,
        .vh-textarea__inner:focus,
        .vh-input__inner:hover,
        .vh-textarea__inner:hover {
          border-color: #999;
        }
      }
      .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #1a1a1a;
        position: relative;
        padding-left: 11px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 4px;
          height: 14px;
          width: 3px;
          background-color: #fb3a32;
        }
        a {
          color: #436dfa;
          margin-left: 6px;
          font-weight: 400;
        }
      }
      .vh-radio-group {
        margin-top: 24px;
        .vh-radio {
          margin-right: 35px;
        }
        .vh-radio__label {
          color: #666;
        }
        .vh-radio__input.is-checked + .vh-radio__label {
          color: #1a1a1a;
        }
        .vh-radio__inner {
          width: 16px;
          height: 16px;
        }
        .vh-radio__inner::after {
          width: 8px;
          height: 8px;
        }
      }
      .input-item {
        margin-top: 24px;
        display: flex;
        align-items: center;
        color: #1a1a1a;
        label {
          min-width: 105px;
          width: 105px;
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          margin-right: 12px;
        }
      }
      &-input {
        width: 555px;
        display: flex;
        align-items: center;
        height: 40px;
        box-sizing: border-box;
        position: relative;
        .save-btn {
          margin-left: 5px;
        }
        &.readOnly {
          border: 1px solid #cccccc;
          padding: 0 0 0 12px;
          background: #f7f7f7;
          border-radius: 4px;
        }
        &.showRulePullUrl {
          input {
            border: 1px solid #fb3a32;
          }
          .alert {
            color: #fb3a32;
            font-size: 12px;
            position: absolute;
            bottom: -17px;
          }
        }
        .input {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          &.success {
            color: #436dfa;
          }
          &.fail {
            color: #fb3a32;
          }
        }
        .tool {
          min-width: 29px;
          padding-right: 12px;
          text-align: right;
          .vh-iconfont {
            cursor: pointer;
            color: #666;
            &:hover {
              color: #1a1a1a;
            }
          }
        }
      }
      .separator {
        width: 100%;
        height: 40px;
      }
      .content {
        margin-top: 8px;
        margin-bottom: 24px;
        padding: 20px;
        background: #f7f7f7;
        border-radius: 4px;
        line-height: 22px;
        font-size: 14px;
        &:last-child {
          margin-bottom: 0;
        }
        .notice {
          margin-top: 5px;
          color: #666;
        }
      }
    }
  }
</style>
